const WHATSAPP_LINK = 'https://wa.me/905321737544?text=Merhaba,%20Google%20reklam%C4%B1ndan%20ula%C5%9F%C4%B1yorum.%20Ak%C3%BC%20/%20yol%20yard%C4%B1m%20veya%20yedek%20par%C3%A7a%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum.';
const PHONE_LINK = 'tel:+905321737544';

export default function MobileBottomBar() {
  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 flex h-16 border-t border-white/10 shadow-2xl">
      <a
        href={PHONE_LINK}
        className="flex-1 flex items-center justify-center gap-2 bg-brand-accent active:bg-brand-accentHover text-white font-bold text-sm transition-colors"
      >
        <i className="fas fa-phone"></i>
        Hemen Ara
      </a>
      <a
        href={WHATSAPP_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="flex-1 flex items-center justify-center gap-2 bg-green-600 active:bg-green-700 text-white font-bold text-sm transition-colors"
      >
        <i className="fab fa-whatsapp text-lg"></i>
        WhatsApp
      </a>
    </div>
  );
}